module.exports = __webpack_public_path__ + "static/media/li.2e6f9feb.svg";